module.exports = __webpack_public_path__ + "img/04.31042769.png";